import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Nav from "./components/Nav";
import Hero from "./components/Hero";
import VideoStats from "./components/VideoStats";
import CollaborationBand from "./components/CollaborationBand";
import About from "./components/About";
import Strengths from "./components/Strengths";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Patents from "./components/Patents";
import JourneyMap from "./components/JourneyMap";
import Contests from "./components/Contests";
import Honors from "./components/Honors";
import Interviews from "./components/Interviews";
import Leaders from "./components/Leaders";
import Footer from "./components/Footer";

import { useReveal } from "./lib/ui";
import { ContactModalProvider } from "./lib/contactModal";
import "@/App.css";

const Portfolio = () => {
  useReveal();
  return (
    <div data-testid="portfolio-root" className="relative bg-alabaster text-ink min-h-screen">
      <Nav />
      <main>
        <Hero />
        <About />
        <VideoStats />
        <CollaborationBand />
        <Strengths />
        {/* <Skills /> hidden per user request */}
        <Patents />
        <Projects />
        <Honors />
        <Interviews />
        <Leaders />
        {/* <Timeline /> hidden per user request */}
        {/* <Contests /> — legacy timeline list, replaced by Honors */}
        {/* <Testimonials /> hidden per user request */}
        {/* <Contact /> hidden per user request — contact handled via modal */}
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
};

function App() {
  return (
    <ContactModalProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </ContactModalProvider>
  );
}

export default App;
